import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { environment } from '@env/environment';
import { ScaffoldDialogRef } from '@app/framework/dialog/scaffold-dialog.service';
import { GraphsService } from '@services/graphs.service';
import { HttpUtilService } from '@services/http-util.service';
import { CourseService } from '@scaffold/services/course.service';
@Component({
    selector: 'app-htmlmodal',
    templateUrl: './htmlmodal.component.html',
    styleUrls: ['./htmlmodal.component.scss'],
    standalone: false
})
export class HTMLModalComponent implements OnInit {
  @ViewChild('contentHolder', { static: false })
  private itemElements: ElementRef;
  data: any = {};
  loading = true;
  constructor(
    private http: HttpUtilService,
    private graphService: GraphsService,
    private element: ElementRef,
    public dialogRef: ScaffoldDialogRef,
    private courseService: CourseService
  ) {}
  url = environment.apiRoot + '/download/pdf';
  ngOnInit() {
    if (this.data.url) {
      this.courseService.get(this.data.url).subscribe({
        next: v => {
          this.data.content = v.html;
          this.loading = false;
          this.afterLoad();
        },
        error: err => {
          console.error('Error fetching content:', err);
          this.loading = false;
          this.data.content = '<p>Error loading content</p>';
        },
      });
    } else {
      this.loading = false;
      this.data.content = this.data.content || '<p>No content available</p>';
      this.afterLoad();
    }
  }

  afterLoad() {
    /* this.itemElements.changes.subscribe(() => {
      console.log("Item elements are now in the DOM!", this.itemElements.length);
      const htmlElement = document.getElementById(this.selectedItemId);
    
  });*/
    let items = document.getElementsByClassName('graph_item');
    for (let i = 0; i < items.length; i++) {
      let item = items[i];
      let settings, values;
      try {
        settings = JSON.parse(item.firstChild.textContent);
        item.innerHTML = '';
      } catch (e) {
        console.log(e);
      }
      console.log(settings);
      values = settings.data_items.map(v => {
        console.log(v.value);
        return parseInt(v.value);
      });
      this.graphService.generatePie(items[i], values, settings);
    }
    console.log(items);
  }

  getPDF(content: string) {
    this.loading = true;
    content = this.itemElements.nativeElement.innerHTML;
    let styles =
      '<link rel="stylesheet" href="https://k16-hosted-lib.s3.us-east-2.amazonaws.com/bootstrapCanvas/pdf_main.css">';
    content = content.replace(/\n/g, '');
    this.http
      .request(
        'post',
        environment.apiRoot + '/download/pdf',
        { html: styles + content, name: this.data.title || this.data.type },
        null,
        true
      )
      .subscribe({
        next: data => {
          window.open(data['url'], '_blank');
          this.loading = false;
        },
        error: error => {
          console.error('Error generating PDF:', error);
          this.loading = false;
        },
      });
  }
}
